import { render, staticRenderFns } from "./showMoreTooltip.vue?vue&type=template&id=65decc64&scoped=true&lang=pug&"
import script from "./showMoreTooltip.vue?vue&type=script&lang=js&"
export * from "./showMoreTooltip.vue?vue&type=script&lang=js&"
import style0 from "./showMoreTooltip.vue?vue&type=style&index=0&id=65decc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65decc64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
